export const HUMAN_FRIENDLY_ACTIONS: {[key: string]: string} = {
  "ASSIGNED": "Assigned to",
  "CANCELED": "Canceled",
  "COMPLETED": "Completed by",
  "CREATED": "Created",
  "EMAIL_SENT": "The email was sent to",
  "MISSED": "Became missed",
  "RESCHEDULED_FROM": "Rescheduled from",
  "RESCHEDULED_TO": "Rescheduled to",
  "UNASSIGNED": "Unassigned"
};